import { Injectable } from "@angular/core";
import { ParentService } from "app/pages/A2-utils/ParentClass/ParentService";
import { Http } from "@angular/http";
import { Router } from "@angular/router";
import { constant } from "app/app.constants";

@Injectable()
export class GeofenceService extends ParentService {
    constructor(private _http: Http, route: Router){
        super();
        this.verifyToken(this._http, route);
    }
    public getZoneFrom(place) {
        return this._http
        .get(`https://nominatim.openstreetmap.org/search.php?polygon_geojson=1&format=json&viewbox=-80.676359,26.884635,-79.923522,25.215657&limit=5&q=${place}`, this.getHeader())
        .map(resp => resp.json());
    }
    public getRegisteredZones(id){
        return this._http.get(`${constant.URL_PAYOR_GEOFENSE_LIST}${id}`,this.getHeader())
        .map(resp => resp.json());
    }
    public saveSelectedZone(zone){
        return this._http.post(`${constant.URL_PAYOR_GEOFENSE}`,zone,this.getHeader())
        .map(resp => resp.json());
    }
    public deleteSavedZone(zoneid){
        return this._http.delete(`${constant.URL_PAYOR_GEOFENSE}/${zoneid}`,this.getHeader())
        .map(resp => resp.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/payors/components/geofence/geofence.service.ts